export default __webpack_public_path__ + "media/quickbooks-logo.18da1.png";